import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useSearchParams } from 'react-router-dom';
import { getApplicationSettings } from 'src/modules/applications/slices';
import { getCurrentCompanyId } from 'src/modules/companies/slices';
import { LinkListItem } from 'src/components/LinkListItem';
import { getSidebarItems } from './constants';
import { SidebarLogo } from './styles';
import { generateUrlWithCompany } from 'src/helpers/helpers';
import { isBhiAdmin } from 'src/helpers/permissions';
import { selectProfile } from 'src/modules/profile/slices';

function Sidebar() {
  const companyId = useSelector(getCurrentCompanyId);
  const settings = useSelector(getApplicationSettings);
  const { profile } = useSelector(selectProfile);
  const [searchParams] = useSearchParams();
  const urlCompanyId = searchParams.get('companyId');
  const selectedCompanyId =
    urlCompanyId || (localStorage.getItem('bhiCurrentCompany') ?? companyId);

  if (!selectedCompanyId) {
    return null;
  }

  return (
    <Drawer
      variant="permanent"
      sx={{
        width: '230px',
        flexShrink: 0,
        zIndex: 10,

        [`& .MuiDrawer-paper`]: {
          width: '230px',
          boxSizing: 'border-box',
        },
      }}
    >
      <Link to="/home">
        <Box>
          <SidebarLogo src={settings?.logo} />
        </Box>
      </Link>

      <Box sx={{ overflow: 'auto' }}>
        <List>
          {getSidebarItems(isBhiAdmin(profile)).map(({ text, icon, path }) => (
            <LinkListItem
              key={text}
              text={text}
              icon={icon}
              to={generateUrlWithCompany(path, companyId)}
            />
          ))}
        </List>
      </Box>
    </Drawer>
  );
}

export default Sidebar;
